import { blockHomeSlider } from "./block-home-slider";
import { blockTextMedia } from "./block-text-media"
import { menu } from "./menu";
import { animation } from "./animation";

/** Init */
$(function () {
  menu();
  blockHomeSlider();
  blockTextMedia();
});
